var exports = {
  "kL": "xaf9ae18d--bb1963--container",
  "iE": "xaf9ae18d--bb1963--wrapper",
};

module.exports = exports;
